<template>
  <v-card flat outlined class="mb-12" color="orange lighten-4">
    <v-card-title>Details</v-card-title>
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="5">
          <v-simple-table>
            <tbody>
              <tr>
                <td>
                  <span style="color:grey">Stage Name</span>
                </td>
                <td>{{ this.stage.name }}</td>
              </tr>
              <tr>
                <td>
                  <span style="color:grey">Operation Id</span>
                </td>
                <td>{{ this.stage.operationId }}</td>
              </tr>
              <tr>
                <td>
                  <span style="color:grey">Status</span>
                </td>
                <td>
                  <v-icon small :color="mapStatusColor(stage.status)">{{
                    mapStatusIcon(stage.status)
                  }}</v-icon
                  >&nbsp;
                  <span :class="mapStatusColor(stage.status) + '--text'"
                    >{{ stage.status }}
                  </span>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-col cols="5">
          <v-simple-table>
            <tbody>
              <tr>
                <td>
                  <span style="color:grey">Start Date</span>
                </td>
                <td>{{ formatDate(stage.startDate) }}</td>
              </tr>
              <tr>
                <td>
                  <span style="color:grey">End Date</span>
                </td>
                <td>{{ formatDate(stage.endDate) }}</td>
              </tr>
              <tr>
                <td>
                  <span style="color:grey">Latest Update</span>
                </td>
                <td>{{ formatDate(stage.latestUpdate) }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-title>Steps</v-card-title>
    <v-card-text>
      Process Inputs:
      <v-simple-table v-if="this.baseStep">
        <thead>
          <tr>
            <th>Status</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Latest Update</th>
            <th v-if="baseStep.error">Error</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <v-icon small :color="mapStatusColor(this.baseStep.status)">{{
                mapStatusIcon(this.baseStep.status)
              }}</v-icon
              >&nbsp;
              <span :class="mapStatusColor(this.baseStep.status) + '--text'"
                >{{ this.baseStep.status }}
              </span>
            </td>
            <td>
              {{ formatDate(this.baseStep.startDate) }}
            </td>
            <td>
              {{ formatDate(this.baseStep.endDate) }}
            </td>
            <td>
              {{ formatDate(this.baseStep.latestUpdate) }}
            </td>
            <td v-if="baseStep.error">
              {{ baseStep.error }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
    <v-card-text v-if="targetKeys">
      <v-tabs v-model="targetTabs">
        <v-tab
          v-for="target in targetKeys"
          :key="target"
          :href="`#tab-${target}`"
          >{{ target }}
        </v-tab>

        <v-tab-item
          v-for="target in targetKeys"
          :key="target"
          :value="'tab-' + target"
        >
          <v-card flat tile>
            <v-data-table
              :headers="headers"
              :items="stepsByTarget[target]"
              :items-per-page="20"
              group-by="target"
              sort-by="startDate"
            >
              <template v-slot:item="{ item, expand, isExpanded }">
                <tr>
                  <td>{{ item.stepName }}</td>
                  <td>
                    <v-icon small :color="mapStatusColor(item.status)">{{
                      mapStatusIcon(item.status)
                    }}</v-icon
                    >&nbsp;
                    <span :class="mapStatusColor(item.status) + '--text'"
                      >{{ item.status }}
                    </span>
                  </td>
                  <td>{{ formatDate(item.startDate) }}</td>
                  <td>{{ formatDate(item.endDate) }}</td>
                  <td v-if="stage.status === 'FAILED'">{{ item.error }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  LIST_SHOWCASE_OPERATION_STEPS,
  ON_UPDATE_OPERATION_STEP
} from '../../constants/query'
import { DOMAIN_NAME } from '@/domain/showcases'
import { formatDate } from '@/domain/showcases/util/timeFormat'
import { mapStatusColor, mapStatusIcon } from '@/domain/showcases/util/status'
import { ON_UPDATE_OPERATION_STAGE } from '@/domain/showcases/constants/query'
export default {
  name: 'OperationStage',
  data: () => ({
    listShowcaseOperationSteps: [],
    listShowcaseOperationStepsErrors: null,
    updatedStep: null,
    stepsByTarget: {},
    targetTabs: 0,
    // targetKeys: [],
    headers: [
      {
        text: 'Step Name',
        value: 'stepName',
        sortable: true,
        icon: 'mdi-alert'
      },
      { text: 'Status', value: 'status', sortable: true },
      { text: 'Start Date', value: 'startDate', sortable: true },
      { text: 'End Date', value: 'endDate', sortable: true }
    ]
  }),
  props: ['stage', 'showcase'],
  apollo: {
    $client: DOMAIN_NAME,
    listShowcaseOperationSteps: {
      query: LIST_SHOWCASE_OPERATION_STEPS,
      fetchPolicy: 'network-only',
      variables() {
        return {
          showcaseId: this.showcase.showcaseId,
          operationId: this.stage.operationId
        }
      },
      result({ data, loading, networkStatus }) {
        this.listShowcaseOperationSteps = data.listShowcaseOperationSteps
        this.setStepsByTarget()
      },
      skip() {
        return !this.stage
      },
      error(error) {
        this.listShowcaseOperationStepsErrors = JSON.stringify(error.message)
      }
      // subscribeToMore: {
      //   document: ON_UPDATE_OPERATION_STEP,
      //   updateQuery: (previousResult, { subscriptionData }) => {
      //     // console.log('Operation Step Updated')
      //     // console.log(subscriptionData.data.onUpdateOperationStep)
      //     // console.log('Previous:')
      //     // console.log(previousResult)
      //     let updatedStep = subscriptionData.data.onUpdateOperationStep
      //     let stepIndex = previousResult.listShowcaseOperationSteps.findIndex(
      //       step => step.stepKey === updatedStep.stepKey
      //     )
      //     if (stepIndex === -1) {
      //       previousResult.listShowcaseOperationSteps.push(
      //         subscriptionData.data.onUpdateOperationStep
      //       )
      //     } else {
      //       previousResult[stepIndex] = updatedStep
      //     }
      //     // this.$apolloProvider.clients[DOMAIN_NAME].writeQuery({
      //     //   query: LIST_SHOWCASE_OPERATION_STEPS,
      //     //   data: { listShowcaseOperationSteps: previousResult }
      //     // })
      //     return previousResult
      //   }
      // }
    },
    $subscribe: {
      updatedStep: {
        query: ON_UPDATE_OPERATION_STEP,
        variables() {
          return {
            operationId: this.stage.operationId
          }
        },
        result({ data }) {
          let updatedStep = data.onUpdateOperationStep
          let stepIndex = this.listShowcaseOperationSteps.findIndex(
            step => step.stepKey === updatedStep.stepKey
          )
          if (stepIndex === -1) {
            this.listShowcaseOperationSteps.push(updatedStep)
          } else {
            this.listShowcaseOperationSteps.splice(stepIndex, 1, updatedStep)
          }
          this.setStepsByTarget()
        }
      },
      updatedStage: {
        query: ON_UPDATE_OPERATION_STAGE,
        variables() {
          return {
            operationId: this.stage.operationId
          }
        },
        result(response) {},
        error(error) {}
      }
    }
  },
  computed: {
    targetKeys() {
      return this.stage.operationTargets.map(target => {
        return target.accountId + ':' + target.region
      })
    },
    baseStep() {
      return this.listShowcaseOperationSteps.filter(step =>
        step.stepKey.startsWith('Base')
      )[0]
    }
  },
  mounted() {
    if (this.stage.status === 'FAILED') {
      this.headers.push({ text: 'Error', value: 'error', sortable: false })
    }

    this.stage.operationTargets
      .map(target => {
        return target.accountId + ':' + target.region
      })
      .forEach(target => {
        this.stepsByTarget[target] = []
      })
  },
  methods: {
    mapStatusColor: mapStatusColor,
    mapStatusIcon: mapStatusIcon,
    formatDate: formatDate,
    setStepsByTarget() {
      this.targetKeys.forEach(target => {
        let mainStep = this.listShowcaseOperationSteps.filter(
          step => step.stepKey === target + ':Main'
        )[0]
        if (mainStep !== undefined) {
          mainStep.target = target
          this.stepsByTarget[target] = this.listShowcaseOperationSteps
            .filter(step => step.stepKey.startsWith(target))
            .map(step => {
              mainStep.targets.forEach(instanceTarget => {
                if (step.stepKey === target + ':' + instanceTarget) {
                  step.stepName = 'Summary of ' + instanceTarget
                  step.target = instanceTarget
                } else if (
                  step.stepKey.startsWith(target + ':' + instanceTarget)
                ) {
                  step.target = instanceTarget
                }
              })
              return step
            })
        }
      })
    },
    closeDialog() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped></style>
